let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("aHG2I"), load("bJvam"), load("fA0SH")]).then(() => parcelRequire('a7dE6'));